import { AssessmentActionTypes } from './actions';
import { IAssessmentSingleState, IGridPayload } from './types';
import { Reducer } from 'redux';
import { AssessmentDataCollectionModel } from '../../pages/Assessment/types';

const initialState: IAssessmentSingleState = {
  isLoading: false,
  error: '',
  data: [],
  saveModalOpened: false,
};
export const assessmentSingleReducer: Reducer<IAssessmentSingleState, any> = (
  state: IAssessmentSingleState = initialState,
  action: any,
): IAssessmentSingleState => {
  switch (action.type) {
    case AssessmentActionTypes.ASSESSMENT_LOADING:
      return { ...state, isLoading: action.payload };
    case AssessmentActionTypes.ASSESSMENT_SET_ASSESSMENT:
      return { ...state, data: action.payload };
    case AssessmentActionTypes.ASSESSMENT_GET_ERROR:
      return { ...state, error: action.payload };
    case AssessmentActionTypes.ASSESSMENT_UPDATE_ASSESSMENT: {
      return {
        ...state,
        data: state.data.map(assessment => ({
          ...assessment,
          Pages: assessment.Pages.map(page => {
            return {
              ...page,
              Fields: page.Fields.map(field => {
                return {
                  ...field,
                  ...action.payload.find(newField => {
                    return newField.ID === field.ID;
                  }),
                };
              }),
            };
          }),
        })),
      };
    }
    case 'ADD_GRID_ROW': {
      return {
        ...state,
        data: addGridRowHelper(state.data, action.payload),
      };
    }
    case 'REMOVE_GRID_ROW': {
      return {
        ...state,
        data: removeGridHelper(state.data, action.payload),
      };
    }
  }
  return state;
};

const addGridRowHelper = (
  state: AssessmentDataCollectionModel[],
  payload: IGridPayload,
): AssessmentDataCollectionModel[] => {
  const newState = [...state];
  const indexOfUpdatedAssessment = newState.findIndex(
    ass => ass.ID === payload.assId,
  );
  const updatedAssessment = state.find(ass => ass.ID === payload.assId);
  const pageToExtend = updatedAssessment.Pages[payload.pageNum];
  const gridToExtend = pageToExtend.Fields.find(
    f => f.Template.Name === payload.gridName,
  );
  const newArrayOfFields = gridToExtend.GridChildren.slice(0, 1);
  const finalFieldsArray = [];
  let lastLenght = gridToExtend.GridChildren.length;
  let lastElement = gridToExtend.GridChildren[lastLenght-1];
  let lastChildId = lastElement[lastElement.length-1].ID;
  newArrayOfFields.forEach(fieldsArray =>
    fieldsArray.forEach(field => {
      const newField = { ...field };
      ++lastChildId;
      newField.GridRow = gridToExtend.GridChildren.length;
      newField.Value = null;
      newField.ID = lastChildId;
      finalFieldsArray.push(newField);
    }),
  );
  gridToExtend.GridChildren.push(finalFieldsArray);
  const indexOfGrid = pageToExtend.Fields.findIndex(
    f => f.Template.Name === gridToExtend.Template.Name,
  );
  pageToExtend.Fields.splice(indexOfGrid, 1, gridToExtend);
  updatedAssessment.Pages[payload.pageNum] = pageToExtend;
  newState.splice(indexOfUpdatedAssessment, 1, updatedAssessment);
  return newState;
};

const removeGridHelper = (
  state: AssessmentDataCollectionModel[],
  payload: IGridPayload,
): AssessmentDataCollectionModel[] => {
  const newState = [...state];
  const indexOfUpdatedAssessment = newState.findIndex(
    ass => ass.ID === payload.assId,
  );
  const updatedAssessment = state.find(ass => ass.ID === payload.assId);
  const pageToExtend = updatedAssessment.Pages[payload.pageNum];
  const grid = pageToExtend.Fields.find(
    f => f.Template.Name === payload.gridName,
  );
  grid.GridChildren.splice(grid.GridChildren.length - 1, 1);
  const indexOfGrid = pageToExtend.Fields.findIndex(
    f => f.Template.Name === grid.Template.Name,
  );
  pageToExtend.Fields.splice(indexOfGrid, 1, grid);
  updatedAssessment.Pages[payload.pageNum] = pageToExtend;
  newState.splice(indexOfUpdatedAssessment, 1, updatedAssessment);
  return newState;
};
